import { jsxs as m, jsx as r } from "react/jsx-runtime";
import { withManagedProps as s } from "@made-people/managed-props";
import { z as o } from "zod";
import { withZod as d } from "@made-people/react-prop-guard";
import { accordionAndTextTemplate1Blueprint as T } from "./index-blueprint.es.js";
import { componentWrapperSchema as p, ComponentWrapper as u } from "@made-people/blueprint-component-wrapper";
import { headingSchema as y, Heading as S } from "@made-people/blueprint-heading";
import { badgeSchema as g, Badge as j } from "@made-people/blueprint-badge";
import { Markdown as w } from "@made-people/blueprint-markdown";
import { accordionSchema as l, Accordion as N } from "@made-people/blueprint-accordion";
import "@made-people/blueprint";
const f = o.object({
  template: o.literal("template1"),
  layout: p.shape.layout.optional(),
  variants: o.custom().optional(),
  text: o.string().optional(),
  accordion: l.array().or(l).optional().transform((t) => Array.isArray(t) ? t[0] : t),
  heading: y.optional(),
  link: o.object({
    label: o.string().optional(),
    href: o.string().optional()
  }).optional(),
  badge: g.optional(),
  children: o.custom().optional()
  // Used for arbitrary CTAs
}).merge(p), k = s(
  "AccordionAndTextTemplate1",
  d(
    {
      schema: f,
      defaultProps: { template: "template1" }
    },
    ({
      variants: t,
      text: i,
      heading: e,
      link: W,
      layout: A,
      badge: a,
      children: h,
      accordion: c,
      ...x
    }) => {
      const n = T.styles(t);
      return /* @__PURE__ */ m(
        u,
        {
          className: n.wrapper,
          ...x,
          layout: { ...A },
          children: [
            /* @__PURE__ */ m("div", { className: n.content, children: [
              (a == null ? void 0 : a.label) && /* @__PURE__ */ r(j, { ...a }),
              (e == null ? void 0 : e.heading) && /* @__PURE__ */ r(S, { ...e }),
              i && /* @__PURE__ */ r(w, { content: i, className: n.text }),
              h
            ] }),
            /* @__PURE__ */ r("div", { className: n.accordionWrapper, children: c && /* @__PURE__ */ r(
              N,
              {
                layout: {
                  spacing: {
                    applySpacing: "false"
                  }
                },
                ...c
              }
            ) })
          ]
        }
      );
    }
  )
), P = o.discriminatedUnion("template", [
  f
]), E = s(
  "AccordionAndText",
  d(P, (t) => t.template === "template1" ? /* @__PURE__ */ r(k, { ...t }) : null)
);
export {
  E as AccordionAndText,
  k as AccordionAndTextTemplate1,
  P as accordionAndTextPropsSchema,
  f as accordionAndTextTemplate1Schema
};
//# sourceMappingURL=index.es.js.map
